import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "grid place-items-center h-screen",
  style: {"height":"calc(100vh - 48px)"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "text-greyblue text-7xl font-bold" }, "avFAI Static Demo UI", -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}